import initialstate from '../../initialstate';
import {DELETE_SUB_SCOPE, PATCH_SUB_SCOPE, POST_SUB_SCOPE, GET_ALL_SCOPES} from '../../../actions/actiontypes';
import normalizeScopes from './normalizeScopes';
import {removeSubScopeById} from './removeSubScope';
import {HttpStatusCodes} from '../../../util/uiconstants';

export default function groupScopesReducer(state = initialstate.groupAudit.scopes, action) {
	switch (action.type) {
		case GET_ALL_SCOPES: {
			return normalizeScopes(action?.response);			
		}
		case POST_SUB_SCOPE: {
			if (action?.responseObj?.status === HttpStatusCodes.Created) {
				let normalizedData = normalizeScopes([action.response]);
				return [...state, ...normalizedData];
			}
			return state;
		}

		case PATCH_SUB_SCOPE: {
			if (action?.responseObj?.status === HttpStatusCodes.Ok) {
				return normalizeScopes(state.map((item) => {
					if (item.gaScopeId === action?.response?.gaScopeId && item.isSubScope) return action.response;
					return item;
				}))
			}
			return state;
		}

		case DELETE_SUB_SCOPE: {
			if (action?.responseObj?.status === HttpStatusCodes.NoContent) {
				return removeSubScopeById(state, action?.meta?.scopeId);
			}
			return state;
		}
		default:
			return state;
	}
}
